'use client';

import { useState } from 'react';
import UserBalancesPortfolioTable from '../UserBalancesPortfolioTable/UserBalancesPortfolioTable';
import { V2SwapHistoryTable } from '../HistoryTables/V2SwapsHistoryTable';
import Tabs from 'src/components/primitives/Tabs/Tabs';
import { TabOption } from 'src/components/primitives/Tabs/types';
import MarginInfo from 'src/components/MarginInfo/MarginInfo';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';

type SwapPageTableTabValue = 'account' | 'balances' | 'history';

const TABLE_OPTIONS: TabOption<SwapPageTableTabValue>[] = [
	{
		value: 'account',
		label: 'Account',
		screenSize: 'mobile',
	},
	{
		value: 'balances',
		label: 'Balances',
	},
	{
		value: 'history',
		label: 'Swap History',
	},
];

const SwapPageTable = () => {
	const [tab, setTab] = useState<SwapPageTableTabValue>('balances');
	const isMobileScreenSize = useIsMobileScreenSize();

	const content = (() => {
		switch (tab) {
			case 'account':
				return <MarginInfo expanded />;
			case 'balances':
			default:
				return (
					<UserBalancesPortfolioTable
						expanded={false}
						showDepositButtonWhenEmpty
						location="trade-page"
					/>
				);
			case 'history':
				return <V2SwapHistoryTable isLive />;
		}
	})();

	return (
		<div className="flex size-full flex-col overflow-hidden rounded-none border-0 bg-container-bg sm:rounded-sm">
			<div className="border-stroke-divider p-md sm:border-b">
				<Tabs
					size={isMobileScreenSize ? 'sm' : 'md'}
					variant="secondary"
					options={TABLE_OPTIONS}
					activeTab={tab}
					onTabChange={setTab}
					className="w-fit"
				/>
			</div>
			<div className="size-full bg-main-bg sm:bg-container-bg">{content}</div>
		</div>
	);
};

export default SwapPageTable;
